import useSWR from 'swr';
import { API_HOST } from '../helpers/constants';
import { fetcher } from '../utils';

export function useBlog(id) {
  const url = `${API_HOST}/blogs/${id}`;

  const { data: responseData, error, isLoading, mutate } = useSWR(id ? url : null, fetcher);

  const revalidate = () => mutate(url);

  return {
    blog: responseData,
    isLoading,
    isError: error,
    revalidate
  };
}
